// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormEquipment } from '~/utils/interface/equipment';
import { EMPTY_STRING } from '~/utils/constants/common';

export const schema = (t: TFunction): yup.ObjectSchema<IFormEquipment> => {
  return yup.object().shape({
    name: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    status: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    rentalStatus: yup.string().optional(),
    note: yup.string().optional(),
    equipmentType: yup.string().optional(),
    isPairingTrailer: yup.boolean().optional(),
    trailerType: yup.array().optional(),
  });
};

export const defaultValuesEquipmentForm: IFormEquipment = {
  name: EMPTY_STRING,
  status: EMPTY_STRING,
  rentalStatus: EMPTY_STRING,
  note: EMPTY_STRING,
  equipmentType: EMPTY_STRING,
  isPairingTrailer: false,
  trailerType: [],
};
